import {
  SingleSelectionConfigurator
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const MCMMandatoryOptOutSurveyConfig = (options) => {
  const {
    i18n,
  } = options;

  return {
    featureArea: 'ESCWeb\\MultiChannelOptOut',
    style: {
      root: {
        minWidth: 600,
      },
    },
    others: {
      isUserInitiatedSurvey: true,
    },
    questions: [
      {
        Type: SingleSelectionConfigurator,
        isRequired: true,
        key: 'q1',
        page: 0,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Why are you opting out your campaign(s)?')),
        isVisible: () => true,
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('The advertiser has separate budgets for search and audience campaigns.')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('The advertiser\'s policies restrict ads from serving.')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('The ads are restricted from serving on the Microsoft Advertising Network per Microsoft Advertising\'s policies.')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('Other (please elaborate below).')),
            placeholder: i18n.getString(_TL_('Please don\'t include any confidential or personal information in your response.')),
            hasInput: true,
            maxLength: 90,
          },
        ],
        data: {
        },
      },
    ],
  };
};
